// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 757 ? "maplibre-gl" : chunkId) + "." + {"358":"721c6062","757":"3802da5d","763":"f13038b6"}[chunkId] + ".chunk.js";
};